import { EnumSituacaoBoleto, EnumTipoCobranca } from '@/views/14/Enums14'
import store from '@/Store'
import { downloadConvertBase64Url } from '@/utils/Download'
import { formatFileForSendWidget } from '@/utils/utils'
import mime from 'mime'

const setupApp = store.state.SetupApp

const detalheBoleto = async (idTitulo, codigoTitulo, idRegistro = null) => {
  let payload = {
    idTitulo: idTitulo,
    codigoTitulo: codigoTitulo
  }
  if (idRegistro) {
    payload = {
      idTitulo: idRegistro,
      codigoTitulo: idRegistro
    }
  }
  const response = await setupApp.apiFuncionalidade.detalhe({
    payload: payload,
    loading: true,
    handlerErrorIgnore: [404]
  })
  return response.data
}

const visualizarBoletoPdf = (detalhe) => {
  let isVisible = false
  const situacao = detalhe.situacao.id
  const tipoCobranca = detalhe.tipoCobranca.id
  if (tipoCobranca === EnumTipoCobranca.boleto) {
    if (setupApp.funcionalidade.parametros.visualizarBoletoEmPdf) {
      if (
        situacao === EnumSituacaoBoleto.aberto ||
        situacao === EnumSituacaoBoleto.vencido
      ) {
        if (detalhe.boletoPdf.ativo) {
          isVisible = true
        }
      }
    }
  }
  return isVisible
}

const visualizarResumoCobranca = (detalhe) => {
  let isVisible = false
  if (setupApp.funcionalidade.parametros.visualizarResumoCobranca) {
    if (detalhe.resumoCobranca.ativo) {
      isVisible = true
    }
  }
  return isVisible
}

const visualizarComprovante = (detalhe) => {
  let isVisible = false
  const situacao = detalhe.situacao.id
  if (setupApp.funcionalidade.parametros.visualizarComprovantePagamento) {
    if (situacao === EnumSituacaoBoleto.pago) {
      if (detalhe.comprovantePagamento.ativo) {
        isVisible = true
      }
    }
  }
  return isVisible
}

const exibirDataPagamento = (detalhe) => {
  let isVisible = false
  const situacao = detalhe.situacao.id
  if (situacao === EnumSituacaoBoleto.pago) {
    if (detalhe.dataPagamento) {
      isVisible = true
    }
  }
  return isVisible
}

const exibirAtualizacaoValor = (detalhe) => {
  let exibir = false
  if (detalhe.atualizacaoValor) {
    exibir = true
  }
  return exibir
}

const acionaFuncionalidade = async (req) => {
  let base64 = ''
  const response = await setupApp.apiFuncionalidade[req.nomeIntegracao]({
    payload: req.integracao.payload,
    loading: true,
    handlerErrorIgnore: true
  })
  if (response.data.url && !response.data.base64) {
    base64 = await downloadConvertBase64Url({ url: response.data.url })
  } else {
    base64 = `data:application/pdf;base64,${response.data.base64}`
  }

  const arquivo = formatFileForSendWidget(base64)
  const data = {
    type: 'arquivo',
    message: `${req.data.tituloWidget}.${mime.getExtension(arquivo.mimeType)}`,
    file: arquivo.file
  }
  return { status: true, data, message: 'sucesso' }
}

const comprovantePdf = async (idTitulo, codigoTitulo) => {
  let payload = {
    idTitulo: idTitulo,
    codigoTitulo: codigoTitulo
  }
  const response = await setupApp.apiFuncionalidade.comprovantePagamentoPdf({
    payload: payload,
    loading: true,
    handlerErrorIgnore: [404]
  })
  return response.data
}

export {
  detalheBoleto,
  visualizarBoletoPdf,
  visualizarResumoCobranca,
  visualizarComprovante,
  exibirDataPagamento,
  exibirAtualizacaoValor,
  acionaFuncionalidade,
  comprovantePdf
}
